export default class Opening {
  constructor(gsap) {
    const mainClass = document.getElementsByTagName("main")[0].classList.value;

    if (mainClass === "top") {
      const headerHeight = 0;

      //TOPページのみオープニングアニメーション
      const urlHashTop = window.location.hash;
      const target = document.getElementById(urlHashTop.slice(1));
      const id = urlHashTop.slice(1);
      if (urlHashTop && target && id === "access") {
        //別ページから#accessに遷移するときはOPアニメーションなし
        //少し遅延させないと挙動おかしくなるので遅延
        setTimeout(() => {
          let position = target.getBoundingClientRect().top + window.scrollY - headerHeight;
          document.querySelector(".page-top").classList.add("-opend");
          document.querySelector(".p-top-overlay").classList.add("-hide");
          window.scrollTo({
            top: position,
            behavior: "smooth",
          });
        }, 500);
      } else {
        // #accessに遷移するとき以外はTOPページはOPアニメーションあり
        openingCircle();
      }
    }
    function openingCircle() {
      let mm = gsap.matchMedia();

      let tl_opening01 = gsap.timeline({}),
        tl_opening02 = gsap.timeline({});

      //クリップパス CSS => aに値を追加することで大きさを調整（必ず中央寄せ）
      const cp = (a) => {
        return "circle(" + a + " at center)";
      };

      const topContents = document.getElementById("p-top-contents");

      // 新しいdiv要素を作成
      let circleDiv = document.createElement("div");
      let circleWrapDiv = document.createElement("div");
      let circleCpDiv = document.createElement("div");
      let circle01Div = document.createElement("div");

      circleDiv.className = "circle";
      circleDiv.id = "circle";

      circleWrapDiv.className = "circle__wrap";

      //コンテンツくり抜き円
      circleCpDiv.className = "circle--cp";
      circleCpDiv.id = "circle--cp";

      //赤円
      circle01Div.className = "circle--01";
      circle01Div.id = "circle--01";

      // 対象のdiv要素の親要素を取得
      const parentDiv = topContents.parentNode;

      // 新しいdiv要素を対象のdiv要素の前に挿入
      parentDiv.insertBefore(circleDiv, parentDiv.firstChild); // 必要に応じて挿入位置を調整

      // 子要素に追加
      circleCpDiv.appendChild(topContents);
      circleWrapDiv.appendChild(circleCpDiv);
      circleDiv.appendChild(circleWrapDiv);

      //赤円はcircle--cpと同階層に設置
      circleWrapDiv.appendChild(circle01Div);
      //----------------
      //赤円
      //----------------
      tl_opening01
        .to(".circle--01", {
          duration: 1,
          clipPath: cp("34%"), //100%になる前に一回36%で停止して緩急つける
          // width: "95vw",
          willChange: "clip-path",
          // delay: 1,
        })
        .to(".circle--01", {
          duration: 0.5,
          clipPath: cp("100%"),
          ease: "expoScale(0.5,7,none)",
        })
        .to(".circle--01", {
          willChange: "unset",
          // opacity: 0,
          display: "none",
          delay: 0,
        })
        .add(() => {
          //オープニングアニメーション終了のタイミングでbodyのスクロールを許可
          document.querySelector(".page-top").classList.add("-opend");
          document.querySelector(".circle").classList.add("-opend");
        });

      //----------------
      //コンテンツくり抜き円
      //----------------
      tl_opening02
        .to(".circle--cp", {
          duration: 0.6,
          delay: 0.4,
          clipPath: cp("5%"), //100%になる前に一回5%で停止して緩急つける
          // width: "95vw",
          willChange: "clip-path",
          // delay: 1,
        })
        .to(".circle--cp", {
          duration: 0.6,
          clipPath: cp("100%"),
          // ease: "expoScale(0.5,7,none)",
          ease: "power3.in",
          // ease: "none",
        })
        .to(".circle--cp", {
          willChange: "unset",
        });
    }
  }
}
